//import 'core-js/stable';
//import 'regenerator-runtime/runtime';

switch (window.location.hostname) {
        case 'kilometer.loc':
        case 'kilometers.loc':
        case 'kmgk-app.ddev.site':
            window.baseroute = 'https://kmgk-app.ddev.site';
            window.baserouteApp = 'https://kmgk-app.ddev.site/app/';
            break;
        case 'dev.kilometergegenkrebs-nrw.de':
            window.baseroute = 'https://dev.kilometergegenkrebs-nrw.de';
            window.baserouteApp = 'https://dev.kilometergegenkrebs-nrw.de/app/';
            break;
        default:
            window.baseroute = 'https://kilometergegenkrebs.de';
            window.baserouteApp = 'https://kilometergegenkrebs.de/app/';
}

import Vue from 'vue';
import App from './App.vue';
import SessionHandling, {sessionState } from './session-handling';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import VModal from 'vue-js-modal';
import VTooltip from 'v-tooltip';
import VUpload from 'vue-upload-component';

import '@/scss/main.scss';

import router from './router';
//import Notifications from './components/Notifications';
import Notifications from 'vue-notification';
import Dialog from './components/DialogCustom';
import VuePureLightbox from 'vue-pure-lightbox';



Vue.config.productionTip = false;

//Vue.component('notifications', Notifications);
Vue.use(sessionState);
Vue.use(Datetime);
Vue.use(Notifications);
Vue.use(VModal, {
  dialog: false,
  clickToClose: false,
});
Vue.component('VDialog', Dialog);
Vue.use(VTooltip, {
  defaultClass: 'kgk-tooltip',
  defaultDelay: 400,
  //defaultOffset: 10,
});
Vue.component('file-upload', VUpload);
Vue.component('VuePureLightbox', VuePureLightbox);


Vue.mixin({
    methods: {
        convertDateReadable(datetime) {
            if (!datetime) return '';
            const date = new Date(datetime);
            
            // Check if the date is valid to prevent "Invalid Date" appearing in UI
            if (isNaN(date.getTime())) return datetime; 

            return new Intl.DateTimeFormat('de-DE').format(date);
        },
        convertDateReadableLong(datetime) {
            return datetime.replace(/^\s*(\d\d\d\d)-(\d\d)-(\d\d) (.+)$/, '$3.$2.$1');
        },
        convertTimeReadable(datetime) {
            //return datetime.replace(/^\s*\d\d(\d\d)-(\d\d)-(\d\d) (.+)$/, '$4');
            return datetime.replace(/^\s*\d\d(\d\d)-(\d\d)-(\d\d) (\d\d):(\d\d):(\d\d)$/, '$4:$5');
        },
        convertDatetimeReadable(datetime) {
            if (!datetime) return '';
            const date = new Date(datetime);
            if (isNaN(date.getTime())) return datetime;

            // 'de-DE' handles the dots and the separator automatically
            return new Intl.DateTimeFormat('de-DE', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false // Uses 24-hour format
            }).format(date).replace(',', ''); // Remove the comma usually added between date and time
        },
        convertNumberReadable(number, rounding) {
            if (typeof rounding === 'number') {
                const factor = Math.pow(10, rounding);
                number = Math.round(number * factor) / factor;
            }
            // Use the built-in German number formatter
            return new Intl.NumberFormat('de-DE').format(number);
        }
    }
});

Vue.directive('kgk-avatar', function(el, binding) {
    el.classList.toggle('kgk-avatar--empty', !binding.value);
    el.style.backgroundImage = binding.value ? `url('${binding.value}')` : '';
});


SessionHandling.init().then(() => {
    new Vue({
        router,
        render: h => h(App)
    }).$mount('#app');
});

// SessionHandling.unregisterAllServiceWorkers(); // @TODO: remove again
SessionHandling.init().then(() => {
    console.log("Session and routes loaded successfully");
}).catch(err => {
    console.error("Session initialization failed", err);
});



/* // global jQuery*/
/*if( typeof jQuery !== 'undefined' ) {
  jQuery(function() {*/
    const elem = document.querySelector('head meta[name=viewport]');
    if( elem ) {
      elem.parentNode.removeChild(elem);
    }

    const viewport = document.createElement('meta');
    viewport.name = 'viewport';
    viewport.content = 'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0';

    document.getElementsByTagName('head')[0].appendChild(viewport);

    //jQuery('head').prepend('<meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0">');
/*  });
}*/
